<div class="page-content-wrapper">
  <!-- Back to Services Button -->
  <div class="mb-1 mt-3 d-flex justify-content-end">
    <button
      @click="goBackToServices"
      class="btn rounded-3 fw-bold btn-dark text-xxs shadow me-2"
    >
      <i class="fas fa-arrow-left me-1"></i>
      {{ backButtonLabel }}
    </button>
  </div>

  <div class="row">
    <div class="col-xl-6 col-12 my-xl-4 mt-2 mb-3">
      <div class="card shadow-md border-1 rounded-3 p-2 h-100">
        <div class="card-body">
          <h5>{{ service_name }}</h5>
          <hr class="h-1" />
          <p class="text-xs">{{ service_description }}</p>
        </div>
      </div>
    </div>

    <div class="col-xl-6 col-12 my-xl-4 my-0">
      <div class="row g-4">
        <div class="col-sm-12 col-md-6">
          <icon-card
            title="No. of Attempts"
            :count="no_of_attempts"
            icon_class="fab fa-cloudsmith"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card
            title="Successful Attempts"
            :count="no_successful"
            icon_class="far fa-check-circle"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card
            title="Success Rate"
            :count="`${Number(success_rate).toFixed(2)} %`"
            icon_class="fas fa-percentage"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card
            title="Cost of Service"
            :count="`R ${Number(cost_of_service).toFixed(2)}`"
            icon_class="fas fa-coins"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="card card-outline-primary mt-2 rounded-3 shadow mt-xl-0 mt-3">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <label class="fw-bold text-center mb-0">
          <i class="fas fa-play-circle text-success fa-xl pt-2 me-1"></i>
          Run Service
        </label>
        <button
          v-if="active_tab !== 'run_service'"
          @click="set_active_tab('run_service')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> View </span>
        </button>
        <button
          v-else
          @click="set_active_tab('')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> Hide </span>
        </button>
      </div>
      <transition name="slide-fade">
        <div v-if="active_tab === 'run_service'">
          <hr class="fw-light" />
          <component
            :is="service_map[service_name.toLowerCase().replace(/ /g, '_')]"
            @service_status_complete="service_status_complete"
          />
        </div>
      </transition>
    </div>
  </div>
  <div class="card card-outline-primary mt-2 rounded-3 shadow">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <label class="fw-bold text-center mb-0">
          <i class="fas fa-folder-tree text-folder fa-xl pt-2 me-1"></i>
          View Results
        </label>
        <button
          v-if="active_tab !== 'view_results'"
          @click="set_active_tab('view_results')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> View </span>
        </button>
        <button
          v-else
          @click="set_active_tab('')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> Hide </span>
        </button>
      </div>

      <transition name="slide-fade">
        <div v-if="active_tab === 'view_results'">
          <hr class="fw-light" />
          <!-- Date range filter aligned right and dropdown on the left for items per page -->
          <div
            class="d-flex justify-content-between align-items-end mb-2 gap-2"
          >
            <!-- Items per page dropdown on the left -->
            <div>
              <label for="items-per-page" class="form-label text-xs mb-0"
                >Items per page</label
              >
              <select
                id="items-per-page"
                class="form-select form-select-sm"
                v-model="results_items_per_page"
                @change="results_current_page = 1"
              >
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </select>
            </div>
            <!-- Date range filter aligned right -->
            <div
              class="d-flex justify-content-end align-items-end gap-2 flex-grow-1"
            >
              <div>
                <label for="date-from" class="form-label text-xs mb-0"
                  >From</label
                >
                <input
                  id="date-from"
                  type="date"
                  class="form-control form-control-sm"
                  v-model="results_search_date_from"
                />
              </div>
              <div>
                <label for="date-to" class="form-label text-xs mb-0">To</label>
                <input
                  id="date-to"
                  type="date"
                  class="form-control form-control-sm"
                  v-model="results_search_date_to"
                />
              </div>
            </div>
            <div
              class="d-flex justify-content align-items-end gap-2 flex-grow-2"
            >
              <div>
                <button
                  class="btn btn-bg-danger rounded btn-sm mb-1"
                  @click="clear_results_filters"
                >
                  Clear
                </button>
              </div>
              <div>
                <button
                  class="btn btn-bg-success rounded btn-sm mb-1"
                  @click="download_results_summary"
                >
                  PDF
                </button>
              </div>
              <div class="dropdown">
                <button
                  class="btn btn-bg-success rounded btn-sm mb-1 dropdown-toggle"
                  type="button"
                  id="summaryExportDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  v-if="summary_export_available"
                >
                  Export
                </button>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="summaryExportDropdown"
                >
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="export_summary_link('csv')"
                    >
                      CSV
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="export_summary_link('excel')"
                    >
                      Excel
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="export_summary_link('json')"
                    >
                      JSON
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Results accordion with dynamic content based on service name -->
          <div class="accordion mb-2" id="results-accordion">
            <!-- Trust Search Response handling -->
            <template
              v-if="service_name?.toLowerCase().includes('trust search')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <TrustSearchReport
                      :trust_search_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>
            <!-- Enterprise AML Response handling -->
            <template
              v-if="service_name?.toLowerCase().includes('enterprise anti money laundering')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="Enterprise Anti-Money Laundering Report"
                      service_type="enterprise_aml"
                      :export_data="result.data"
                    >
                      <EnterpriseAmlVerificationReport
                        :aml_data="result.data"
                        :sheet_elements="`#collapse-${index} .sheet`"
                      />
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>
            <!-- Enterprise KYB Response handling -->
            <template
              v-if="service_name?.toLowerCase().includes('enterprise kyb')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <EnterpriseKYBReport
                      :kyb_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>
            <!-- Experian Credit Report Response handling -->
            <template
              v-else-if="service_name?.toLowerCase().includes('experian credit report')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <CreditReport :credit_data="result.data" />
                  </div>
                </div>
              </div>
            </template>
            <!-- Namibia Credit Report Response handling -->
            <template
              v-else-if="service_name?.toLowerCase().includes('credit report namibia')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="Credit Report Namibia"
                      :service_type="credit_report_namibia"
                      :export_data="result.data"
                    >
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>
            <!-- AML Response handling -->
            <template
              v-else-if="service_name?.toLowerCase().includes('anti money laundering')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in filtered_aml_data"
                :key="index"
              >
                <div v-if="result.response">
                  <div
                    class="card-header bg-white d-flex justify-content-between align-items-center"
                    :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                    :id="'heading-' + index"
                    @click="toggle_accordion(index)"
                  >
                    <h2 class="text-center p-1 text-muted fw-bold text-xs">
                      {{ get_result_title(result) }}
                    </h2>
                    <i
                      :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                    ></i>
                  </div>
                  <div
                    :id="'collapse-' + index"
                    class="collapse aml-result"
                    :aria-labelledby="'heading-' + index"
                    data-parent="#results-accordion"
                  >
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="Anti-Money Laundering Report"
                      service_type="aml"
                      :export_data="result.response"
                    >
                      <AMLReport
                        :aml_data="aml_results(result)"
                        :response_info="response_info_aml(result)"
                        :sheet_elements="`#collapse-${index} .sheet`"
                        :date_scored="date_scored(result)"
                      />
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>

            <!-- Enterprise Credit Check Response handling -->
            <template
              v-else-if="service_name?.toLowerCase().includes('enterprise credit check')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="Enterprise Credit Check Report"
                      service_type="enterprise_credit"
                      :export_data="result.data"
                    >
                      <CompanyCreditReport
                        :customer_credit_data="result.data"
                        :sheet_elements="`#collapse-${index} .sheet`"
                      />
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('rsa id verification')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="RSA ID Verification Report"
                      service_type="rsa_id_verification"
                      :export_data="result.data"
                    >
                      <RsaIdVerificationReport
                        :rsa_id_data="result.data"
                        :customer_image="customer_image_base_64"
                        :sheet_elements="`#collapse-${index} .sheet`"
                      />
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>

              <template
              v-else-if="service_name?.toLowerCase().includes('telephones')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <ReportViewer
                      :response_doc="result.response_doc"
                      title="Telephone Report"
                      service_type="telephones"
                      :export_data="result.data"
                    >
                    </ReportViewer>
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('refugee verification')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <RefugeeVerificationReport
                      :refugee_verification_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('bank account individual verification')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <IndividualBankAccountReport
                      :bank_account_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('bank account company verification')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <CompanyBankAccountReport
                      :company_account_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('income estimator')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <IncomeEstimatorReport
                      :income_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('income predictor')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <IncomePredictorReport
                      :income_predictor_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="service_name?.toLowerCase().includes('address match')"
            >
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <h2 class="text-center p-1 text-muted fw-bold text-xs">
                    {{ get_result_title(result) }}
                  </h2>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <AddressVerificationReport
                      :address_data="result.data"
                      :sheet_elements="`#collapse-${index} .sheet`"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div
                class="card mb-2 rounded-3"
                v-for="(result, index) in all_filtered_results"
                :key="index"
              >
                <div
                  class="card-header bg-white d-flex justify-content-between align-items-center"
                  :class="{ 'border-none border-bottom rounded-3': !is_accordion_open(index) }"
                  :id="'heading-' + index"
                  @click="toggle_accordion(index)"
                >
                  <div
                    v-if="service_name?.toLowerCase().includes('address match')"
                  >
                    <h2 class="text-center p-1 text-muted fw-bold text-xs">
                      {{ get_result_title(result) }}
                    </h2>
                  </div>
                  <div v-else>
                    <h2 class="text-center p-1 text-muted fw-bold text-xs">
                      {{ get_result_title(result) }}
                    </h2>
                  </div>
                  <i
                    :class="{ 'fas fa-chevron-down': !is_accordion_open(index), 'fas fa-chevron-up': is_accordion_open(index) }"
                  ></i>
                </div>
                <div
                  :id="'collapse-' + index"
                  class="collapse"
                  :aria-labelledby="'heading-' + index"
                  data-parent="#results-accordion"
                >
                  <div class="card-body mb-3">
                    <table
                      class="table table-bordered w-100 d-none"
                      :id="'results-table-' + index"
                    >
                      <thead>
                        <tr>
                          <th>Label</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, itemIndex) in result.data"
                          :key="itemIndex"
                        >
                          <td>{{ item.label }}</td>
                          <td v-if="item.label === 'FacialImage'">
                            <img
                              :src="'data:image/jpeg;base64,' + item.value"
                              class="facial-image-result"
                              alt="Facial Image"
                            />
                          </td>
                          <td v-else>{{ item.value }}</td>
                        </tr>
                        <tr v-if="customer_image">
                          <td>Customer Image</td>
                          <td>
                            <img
                              :src="customer_image"
                              class="facial-image-result"
                              alt="Customer Image"
                            />
                          </td>
                        </tr>
                        <tr v-if="result.document_images?.Portrait">
                          <td>Portrait Image</td>
                          <td>
                            <img
                              :src="result.document_images.Portrait"
                              class="facial-image-result"
                              alt="Portrait Image"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Special handling for FacialImage -->
                      <div
                        class="col-12"
                        v-if="Array.isArray(result.data) && result.data.some(item => item.label === 'FacialImage')"
                      >
                        <div class="w-100 text-center mb-4">
                          <label
                            class="form-label text-s fw-bold d-block mb-1 mt-4"
                          >
                            Facial Image Comparison
                          </label>
                          <div
                            class="d-flex justify-content-center align-items-center gap-3 mx-auto"
                          >
                            <div
                              v-if="result.data.find(item => item.label === 'FacialImage')?.value"
                              class="image-container"
                            >
                              <p class="text-dark small mb-2">Service Image</p>
                              <img
                                :src="'data:image/jpeg;base64,' + result.data.find(item => item.label === 'FacialImage')?.value"
                                class="facial-image img-fluid rounded shadow-sm"
                                alt="Service Facial Image"
                              />
                            </div>
                            <div v-if="customer_image" class="image-container">
                              <p class="text-dark small mb-2">Customer Image</p>
                              <img
                                :src="customer_image"
                                class="facial-image img-fluid rounded shadow-sm"
                                alt="Customer Facial Image"
                              />
                            </div>
                            <div
                              v-if="result.document_images?.Portrait"
                              class="image-container"
                            >
                              <p class="text-dark small mb-2">Portrait Image</p>
                              <img
                                :src="result.document_images.Portrait"
                                class="facial-image img-fluid rounded shadow-sm"
                                alt="Customer Facial Image"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Regular handling for other data items -->
                      <template
                        v-for="(item, item_index) in Array.isArray(result.data) ? result.data : []"
                        :key="item_index"
                      >
                        <template v-if="item.label !== 'FacialImage'">
                          <div
                            class="col-md-6 mb-2"
                            v-if="item.type === 'input'"
                          >
                            <label class="form-label text-xs fw-bold">
                              {{ format_label(item.label) }}
                            </label>
                            <input
                              type="text"
                              class="form-control text-xs rounded-small p-3 shadow-sm"
                              :value="item.value"
                              disabled
                            />
                          </div>
                          <div
                            v-else-if="item.type === 'heading'"
                            class="col-12"
                          >
                            <h5 class="text-dark mt-4 mb-3 fw-bold">
                              {{ format_label(item.label) }}
                            </h5>
                          </div>
                        </template>
                      </template>

                      <!-- Special handling for displaying the url_link document-->
                      <div
                        class="col-12 mb-4"
                        v-if="Array.isArray(result.data) && result.data.some(item => check_document_url(item))"
                      >
                        <label
                          class="form-label text-s fw-bold d-block mb-1 mt-4"
                        >
                          Document Preview
                        </label>
                        <div
                          v-for="(item, item_index) in result.data"
                          :key="'url_link-' + item_index"
                        >
                          <div v-if="check_document_url(item)">
                            <div class="ratio ratio-1x1">
                              <iframe
                                class="w-100 border-0"
                                :src="item.value"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 mb-4"
                        v-if="service_name?.toLowerCase().includes('cipc plus score')"
                      >
                        <label
                          class="form-label text-s fw-bold d-block mb-1 mt-4"
                        >
                          Document Preview
                        </label>
                        <p
                          class="text-xs text-muted mb-2"
                          v-if="result.data.ExpiresIn"
                        >
                          <i class="fas fa-clock me-1"></i>{{
                          result.data.ExpiresIn }}
                        </p>
                        <template
                          v-if="result.data.url_link && result.data.url_link.startsWith('http')"
                        >
                          <div class="ratio ratio-1x1">
                            <iframe
                              class="w-100 border-0"
                              :src="result.data.url_link"
                            ></iframe>
                          </div>
                        </template>
                        <div v-else class="alert alert-info text-xs">
                          <i class="fas fa-spinner fa-spin me-2"></i>
                          Document is being generated. Please wait...
                          <button
                            class="btn btn-sm btn-outline-primary ms-3"
                            @click="get_service_information()"
                          >
                            <i class="fas fa-sync-alt me-1"></i> Refresh
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- Paginator for results -->
          <div class="d-flex justify-content-between align-items-center mt-2">
            <button
              class="btn btn-sm btn-outline-secondary me-2"
              @click="results_previous_page"
              :disabled="results_current_page === 1"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <span class="text-xs my-2"
              >Page {{ results_current_page }} of {{ results_total_pages
              }}</span
            >
            <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click="results_next_page"
              :disabled="results_current_page === results_total_pages"
            >
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <!-- Updated Service Log section with responsive table, updated search input, and paginator styling -->
  <div class="card card-outline-primary mt-2 rounded-3 shadow">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <label class="fw-bold text-center mb-0">
          <i class="fas fa-book text-secondary fa-xl pt-2 me-1"></i>
          Service Log
        </label>
        <button
          v-if="active_tab !== 'service_log'"
          @click="set_active_tab('service_log')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> View </span>
        </button>
        <button
          v-else
          @click="set_active_tab('')"
          class="btn btn-primary-color rounded-pill text-xs"
        >
          <span> Hide </span>
        </button>
      </div>
      <transition name="slide-fade">
        <div v-if="active_tab === 'service_log'">
          <hr class="fw-light" />
          <!-- Updated search input styling -->
          <div class="d-flex justify-content-end mb-2">
            <input
              type="text"
              class="form-control w-50"
              v-model="search_query"
              placeholder="Search Log..."
            />
          </div>
          <!-- Added responsive table container and updated table classes -->
          <div class="table-responsive">
            <table
              class="table table-striped table-bordered table-hover table-sm text-xs"
            >
              <thead>
                <tr>
                  <th class="text-xs">No</th>
                  <th class="text-xs">Verification Status</th>
                  <th class="text-xs">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in filtered_logs" :key="log.id">
                  <td class="py-2">{{ log.no }}</td>
                  <td class="py-2">{{ log.status }}</td>
                  <td class="py-2">{{ log.date }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="h-1" />
          <!-- Updated paginator styling remains similar -->
          <div class="d-flex justify-content-between align-items-center">
            <button
              class="btn btn-sm btn-outline-secondary me-2"
              @click="previous_page"
              :disabled="current_page === 1"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <span class="text-xs my-2"
              >Page {{ current_page }} of {{ total_pages }}</span
            >
            <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click="next_page"
              :disabled="current_page === total_pages"
            >
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</div>
